import React from 'react';
import Page from '../../layout/Page';
import Deals from './Deals';

const DealsPage = () => (
    <Page title='Deals' icon='mobile'>
        <Deals />
    </Page>
);

export default DealsPage;
